// extracted by mini-css-extract-plugin
export default {"videoList":"videoList__3dmzG"};